import { UsageHelper } from '@employee-experience/common/lib/Models/UsageTelemetry';
import { getTelemetryConfig } from './telemetryConfig';
import { TelemetryService } from './telemetryService';
export var getTelemetryClient = function (environment, clientId, clientAppName, sourceComponentContext) {
    var appName = clientAppName !== undefined ? clientAppName : clientId;
    var sourceComponent = sourceComponentContext !== undefined ? sourceComponentContext : clientId;
    var usageHelper = appName && appName.trim() !== '' ? UsageHelper.Fork(appName) : UsageHelper;
    var telemetryContext = {
        sourceComponent: sourceComponent,
        sourceScript: sourceComponent,
        setUsageEvent: usageHelper.MassageEvent,
        setUsageUser: function (usageUser) {
            UsageHelper.SetUser(usageUser);
            usageHelper.SetUser(usageUser);
            return usageUser;
        },
        usageUser: usageHelper.GetUser,
        setUsageConfig: usageHelper.SetUsageConfig,
        getChildContext: usageHelper.ForkTelemetryContext,
    };
    var telemetryService = new TelemetryService(getTelemetryConfig(environment, clientId), telemetryContext);
    return telemetryService;
};
